﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpManagerView = void 0;
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const com = require("../tmpls");
const App_1 = require("../../App");
class UpManagerView extends com.CmpBlockUpManager {
    constructor(contract) {
        super();
        this._contract = contract;
        this.ctrls.btnUpdate.onclick = () => this.update();
        this.ctrls.btnUpdateSelectively.onclick = () => this.updateSel();
        this.ctrls.btnUpdate.disable();
        this.ctrls.btnUpdateSelectively.disable();
        this._fastRefresh();
        this.ctrls.btnAdditional.onclick = () => {
            this._showAdditionalAsync();
        };
    }
    _fastRefresh() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ctrls.lAddress.text = this._contract.address;
            const started = yield this._contract.getStarted();
            if (started)
                this.ctrls.lState.text = "State: Working";
            else
                this.ctrls.lState.text = "Not started";
            this.ctrls.btnUpdate.enable();
            const needUpdate = yield this._contract.needUpdate();
            if (needUpdate) {
                this.ctrls.btnUpdateSelectively.enable();
            }
            else {
                this.ctrls.btnUpdateSelectively.disable();
            }
        });
    }
    _showAdditionalAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.ctrls.blockAdditional.hasClass('d-none')) {
                this.ctrls.blockAdditional.hide();
                return;
            }
            this.ctrls.blockAdditional.show();
            this.ctrls.lTokenUP.text = yield this._contract.getTokenUP();
            this.ctrls.lTokenUSDL.text = yield this._contract.getTokenUSDL();
            this.ctrls.lTokenLOAN.text = yield this._contract.getTokenLOAN();
            this.ctrls.lLLVaultManager.text = yield this._contract.getLLVaultManager();
            this.ctrls.lLLBorrower.text = yield this._contract.getLLBorrower();
            this.ctrls.lLLStakePool.text = yield this._contract.getLLStakePool();
            this.ctrls.lLLStabilityPool.text = yield this._contract.getLLStabilityPool();
            //this.ctrls.lLLHintHelpers.text = await this._contract.getLLHintHelpers();
            const started = yield this._contract.getStarted();
            this.ctrls.lTradeBot.text = yield this._contract.getTradeBot();
            this.ctrls.lDelegatedSwapper.text = yield this._contract.getDelegatedSwapper();
            this.ctrls.lRewardPool.text = yield this._contract.getRewardPool();
            this.ctrls.lPriceKeeperUP.text = yield this._contract.getPriceKeeperUP();
            this.ctrls.lPriceKeeperPLS.text = yield this._contract.getPriceKeeperPLS();
            this.ctrls.lBuyBurnPool.text = yield this._contract.getBuyBurnPool();
            this.ctrls.lStabilityPool.text = yield this._contract.getStabilityPool();
            this.ctrls.lInternalExchangerBnB.text = yield this._contract.getInternalExchangerBnB();
            this.ctrls.lInternalExchangerSP.text = yield this._contract.getInternalExchangerSP();
            this.ctrls.lLiquidControllersDeployer.text = yield this._contract.getLiquidControllersDeployer();
            if (started) {
                let vaultInfo = [];
                let index = 0;
                for (const v of App_1.App.Inst.chain.liquidControllers) {
                    vaultInfo.push(index + ": " + v.address);
                    index++;
                }
                this.ctrls.lVaults.html = '<br>' + vaultInfo.join('<br>');
            }
            // this.ctrls.lBalance.text = await this._contract.getBalance();
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.chain.getAccountAsync();
            yield this._contract.update();
        });
    }
    updateSel() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnUpdateSelectively.disable();
            try {
                yield App_1.App.Inst.chain.getAccountAsync();
                let bnbPool = yield App_1.App.Inst.chain.buyBurnPool.needUpdate();
                if (bnbPool)
                    bnbPool = yield App_1.App.Inst.chain.buyBurnPool.checkUpdateWorkable();
                let sPool = yield App_1.App.Inst.chain.stabilityPool.needUpdate();
                if (sPool)
                    sPool = yield App_1.App.Inst.chain.stabilityPool.checkUpdateWorkable();
                let lcs = [];
                let index = 0;
                let needLCSUpdate = false;
                for (const v of App_1.App.Inst.chain.liquidControllers) {
                    let needUpdate = yield v.needUpdate();
                    if (needUpdate)
                        needUpdate = yield v.checkUpdateWorkable();
                    if (needUpdate)
                        lcs.push(index);
                    index++;
                }
                if (!sPool && !bnbPool && lcs.length == 0) {
                    new modalCom.DialogOk("No need to update", "Attention").show();
                    return;
                }
                yield this._contract.updateSelectively(bnbPool, sPool, lcs);
            }
            catch (e) {
                this.ctrls.btnUpdateSelectively.enable();
                throw e;
            }
            this.ctrls.btnUpdateSelectively.enable();
        });
    }
}
exports.UpManagerView = UpManagerView;
//# sourceMappingURL=UpManagerView.js.map